import React from 'react'
import { Row, Container, Col, Image } from "react-bootstrap";
import { Link } from 'react-router-dom';

import service1 from "../../Assets/services/service-1.png"
import service2 from "../../Assets/services/service-2.png"
import service3 from "../../Assets/services/service-3.png"
import service4 from "../../Assets/services/service-4.png"
import service5 from "../../Assets/services/service-5.png"

export default function Services() {
    return (
        <section className='padding-section-large bg-gradient-1'>
            <Container>
                <Row className='mb-4'>
                    <Col md={9}>
                        <h2 className="heading-style-h2 pb-3">More Than Just a <span className="text-gradient-1">Software Company</span></h2>
                        <h5 className='heading-style-h5 pb-5'>A perspective formed through experience and a focus on getting things right over time. </h5>
                    </Col>
                </Row>
                <Row className="align-items-center mb-5 serviceCard serviceCard1  p-4">
                    {/* LEFT CONTENT */}
                    <Col md={9} className='flex-row d-flex gap-3 p-0'>
                        <div>
                            <Image src={service1} className='w-56' />
                        </div>
                        <div className="banner-content">
                            <h4 className='heading-style-h4'>Custom Software Development</h4>

                            <h5 className='heading-style-h5 my-3'>Designed to fit how your business works, not force it to adapt. </h5>

                            <p className="desc">From concept to deployment, we build mobile applications that are easy to use and consistent in how they perform across platforms and devices. </p>

                            {/* LINKS */}
                            <div className="banner-links text-gradient-1 mb-4">
                                <span>End-to-end development</span>
                                <span>Scalable architecture</span>
                                <span>Ongoing support and optimization</span>
                            </div>

                            {/* BUTTON */}
                            <Link to="/custom_software" className="btn btn-outline-dark rounded-pill text-uppercase">
                                Custom Software Development
                            </Link>

                        </div>
                    </Col>

                    {/* RIGHT IMAGE */}
                    <Col md={3} className="p-0">

                    </Col>

                </Row>

                <Row className="align-items-center mb-5 serviceCard serviceCard2  p-4">
                    {/* LEFT CONTENT */}
                    <Col md={9} className='flex-row d-flex gap-3 p-0'>
                        <div>
                            <Image src={service2} className='w-56' />
                        </div>
                        <div className="banner-content">
                            <h4 className='heading-style-h4'>Mobile Application Development</h4>

                            <h5 className='heading-style-h5 my-3'>Designed to feel effortless in use, and reliable behind the scenes. </h5>

                            <p className="desc">From concept to deployment, we build mobile applications that are easy to use and consistent in how they perform across platforms and devices. </p>

                            {/* LINKS */}
                            <div className="banner-links text-gradient-1 mb-4">
                                <span>iOS and Android development</span>
                                <span>Cross-platform solutions</span>
                                <span>Performance-focused builds</span>
                            </div>

                            {/* BUTTON */}
                            <Link to="/mobile_application" className="btn btn-outline-dark rounded-pill text-uppercase">
                                EXPLORE MOBILE APPLICATION DEVELOPMENT
                            </Link>

                        </div>
                    </Col>

                    {/* RIGHT IMAGE */}
                    <Col md={3} className="p-0">

                    </Col>

                </Row>

                <Row className="align-items-center mb-5 serviceCard serviceCard3  p-4">
                    {/* LEFT CONTENT */}
                    <Col md={9} className='flex-row d-flex gap-3 p-0'>
                        <div>
                            <Image src={service3} className='w-56' />
                        </div>
                        <div className="banner-content">
                            <h4 className='heading-style-h4'>DevOps & Cloud Solutions</h4>

                            <h5 className='heading-style-h5 my-3'>Keeping systems running smoothly, with clarity across how they’re managed. </h5>

                            <p className="desc">We help improve deployment cycles, system stability and infrastructure management through structured DevOps and cloud practices. </p>

                            {/* LINKS */}
                            <div className="banner-links text-gradient-1 mb-4">
                                <span>CI/CD pipelines</span>
                                <span>Cloud infrastructure management</span>
                                <span>Performance monitoring</span>
                            </div>

                            {/* BUTTON */}
                            <Link to="/devops_cloud" className="btn btn-outline-dark rounded-pill text-uppercase">
                                EXPLORE DevOps & Cloud Solutions
                            </Link>

                        </div>
                    </Col>

                    {/* RIGHT IMAGE */}
                    <Col md={3} className="p-0">

                    </Col>

                </Row>

                <Row className="align-items-center mb-5 serviceCard serviceCard4  p-4">
                    {/* LEFT CONTENT */}
                    <Col md={9} className='flex-row d-flex gap-3 p-0'>
                        <div>
                            <Image src={service4} className='w-56' />
                        </div>
                        <div className="banner-content">
                            <h4 className='heading-style-h4'>Quality Assurance & Testing</h4>

                            <h5 className='heading-style-h5 my-3'>Making sure things work the way they should, every single time. </h5>

                            <p className="desc">Our QA approach focuses on catching issues early and keeping systems stable through structured testing. </p>

                            {/* LINKS */}
                            <div className="banner-links text-gradient-1 mb-4">
                                <span>Manual and automated testing</span>
                                <span>Performance and load testing</span>
                                <span>Continuous quality checks</span>
                            </div>

                            {/* BUTTON */}
                            <Link to="/qa_testing" className="btn btn-outline-dark rounded-pill text-uppercase">
                                EXPLORE Quality Assurance & Testing
                            </Link>

                        </div>
                    </Col>

                    {/* RIGHT IMAGE */}
                    <Col md={3} className="p-0">

                    </Col>

                </Row>

                <Row className="align-items-center serviceCard serviceCard5 p-4">
                    {/* LEFT CONTENT */}
                    <Col md={9} className='flex-row d-flex gap-3 p-0'>
                        <div>
                            <Image src={service5} className='w-56' />
                        </div>
                        <div className="banner-content">
                            <h4 className='heading-style-h4'>Offshore Team Setup</h4>

                            <h5 className='heading-style-h5 my-3'>An extension of your team, aligned with how you already work.  </h5>

                            <p className="desc">We build and manage offshore teams that integrate smoothly into your workflows, so delivery stays consistent without adding friction.  </p>

                            {/* LINKS */}
                            <div className="banner-links text-gradient-1 mb-4">
                                <span>Dedicated development teams</span>
                                <span>Seamless team integration</span>
                                <span>Long-term engagement support</span>
                            </div>

                            {/* BUTTON */}
                            <Link to="/offshore_team" className="btn btn-outline-dark rounded-pill text-uppercase">
                                EXPLORE Offshore Team Setup
                            </Link>

                        </div>
                    </Col>

                    {/* RIGHT IMAGE */}
                    <Col md={3} className="p-0">

                    </Col>

                </Row>
            </Container>
        </section>
    )
}
